import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { camelCase, isNull, isUndefined } from 'lodash-es';
import { safeInvoke, Enum, isDefined } from '../../../../library';
import { MapContext } from './interactive-map';
export var MarkerEventType = Enum({
  ANIMATION_CHANGED: 'animation_changed',
  CLICK: 'click',
  CLICKIBLE_CHANGED: 'clickable_changed',
  CURSOR_CHANGED: 'cursor_changed',
  DBLCLICK: 'dblclick',
  DRAG: 'drag',
  DRAGEND: 'dragend',
  DRAGGABLE_CHANGED: 'draggable_changed',
  DRAGSTART: 'dragstart',
  FLAT_CHANGED: 'flat_changed',
  ICON_CHANGED: 'icon_changed',
  MOUSEDOWN: 'mousedown',
  MOUSEOUT: 'mouseout',
  MOUSEOVER: 'mouseover',
  MOUSEUP: 'mouseup',
  POSITION_CHANGED: 'position_changed',
  RIGHTCLICK: 'rightclick',
  SHAPE_CHANGED: 'shape_changed',
  TITLE_CHANGED: 'title_changed',
  VISIBLE_CHANGED: 'visible_changed',
  ZINDEX_CHANGED: 'zindex_changed'
});
export var Marker = function Marker(props) {
  var _React$useContext = React.useContext(MapContext),
    gApi = _React$useContext.gApi,
    map = _React$useContext.map;
  var _React$useState = React.useState(),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    stateMarker = _React$useState2[0],
    setMarker = _React$useState2[1];
  var _React$useState3 = React.useState({}),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    listeners = _React$useState4[0],
    setListeners = _React$useState4[1];
  React.useEffect(function () {
    var newMarker = createMarker();
    setMarker(newMarker);
    return function cleanup() {
      removeMarker(newMarker);
    };
  }, []);
  React.useEffect(function () {
    if (isDefined(stateMarker)) {
      var _props$position;
      stateMarker.setPosition((_props$position = props.position) !== null && _props$position !== void 0 ? _props$position : null);
    }
  }, [props.position]);
  var createMarker = function createMarker() {
    if (isNull(gApi)) return;
    var newMarker = new gApi.maps.Marker(_objectSpread(_objectSpread({}, props), {}, {
      map: map
    }));
    var addListeners = Object.values(MarkerEventType).reduce(function (acc, e) {
      var listener = newMarker.addListener(e, handleEvent(e, newMarker));
      acc[e] = listener;
      return acc;
    }, {});
    setListeners(addListeners);
    return newMarker;
  };
  var removeMarker = function removeMarker(marker) {
    if (isNull(gApi) || isUndefined(marker)) return;
    Object.keys(listeners).forEach(function (e) {
      gApi.maps.event.removeListener(listeners[e]);
    });
    marker.setMap(null);
  };
  var handleEvent = function handleEvent(evtName, marker) {
    var timeout;
    var handlerName = camelCase("on_".concat(evtName));
    return function (e) {
      if (isDefined(timeout)) {
        clearTimeout(timeout);
        timeout = null;
      }
      timeout = window.setTimeout(function () {
        safeInvoke(props[handlerName], props, marker, e);
      }, 0);
    };
  };
  return React.createElement("div", null);
};
Marker.displayName = 'MapMarker';
Marker.defaultProps = {};